import React from "react";
import { useField } from "formik";
import { TextField, Box, Typography } from "@mui/material";

interface Props {
  placeholder: string;
  name: string;
  rows: number;
  label?: string;
  required?: boolean;
}

export default function MyTextAreaInput(props: Props) {
  const [field, meta] = useField(props.name);
  return (
    <Box sx={{ mb: 2 }}>
      <TextField
        {...field}
        {...props}
        multiline
        rows={props.rows}
        placeholder={props.placeholder}
        name={field.name}
        onChange={field.onChange}
        onBlur={field.onBlur}
        value={field.value ?? ""}
        error={meta.touched && !!meta.error}
        fullWidth
        variant="standard"
        // Do not show label unless explicitly provided
        label={props.label ? props.label : undefined}
      />
      {meta.touched && meta.error && (
        <Typography color="error" variant="caption">
          {meta.error}
        </Typography>
      )}
    </Box>
  );
}
